<template lang="pug">
.subscribe-modal
  y-dialog(v-model="dialog" persistent scrollable :fullscreen="$vuetify.breakpoint.xsOnly" max-width="600px")
    v-card(min-height="80vh")
      v-card-title.px-4
        v-layout
          eva-icon.mr-4(name="close-outline" :fill="$vuetify.theme.themes[$theme].primary500" @click="dialog = false")
          .h6.textColor--text Purchase add-on

      v-layout.my-6(v-if="isFetching")
        v-row.fill-height.ma-0(align='center' justify='center')
          v-progress-circular.ma-auto(:width="2" :size="50" color="primary" indeterminate)

      v-card-text.px-4(v-else)
        v-window(v-model="step")
          v-window-item(:value="0")
            // =========================================================================================================
            //  1. View Plan
            // =========================================================================================================
            .h6.textColor--text.text-center.mt-8 You are subscribing to:
            .h4.textColor--text.text-center.mt-6 Reminder Scheduling
            .h4.textColor--text.text-center.mt-6 5
            .p1.primary400--text.text-center.mt-6 RM per month with {{ selectedContract.billing_cycle }} contract
            v-card.pa-6.ma-6.basic300(flat)
              .p2 You will get access to:
              .p2.mt-6 1. Scheduling reminders for your customers’ invoices
              .p2 2. Scheduling reminders for your expense payments
              .p2 3. View and manage scheduled reminders
              .p2 4. View sent reminders history

          v-window-item(:value="1")
            // =========================================================================================================
            //  2. Select payment method
            // =========================================================================================================
            .h5.textColor--text.text-center.mt-8 Select payment method
            v-card.mt-8(flat outlined style="border:1px solid var(--v-basic300);")
              v-radio-group.mt-n1(v-model="selectedPaymentMethod" hide-details)
                v-layout(style="cursor: pointer" @click="selectedPaymentMethod = 'card'")
                  v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                    eva-icon.ma-auto(name="credit-card-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
                  v-col.pa-0.my-auto
                    v-layout.py-4
                      div.my-auto.pr-2
                        .s1.basic800--text Credit or debit card
                  v-col.pa-0.shrink.mt-5
                    v-radio.my-0.py-0.mr-2(value="card" readonly)
                v-divider.basic300
                v-layout(:style="form.commitment === 'monthly' ? 'cursor: default' : 'cursor: pointer'" @click="form.commitment === 'monthly' ? '' : selectedPaymentMethod = 'fpx'")
                  v-layout.mt-1(style="height:56px; max-width:56px; min-width:56px;")
                    BuildingBankIcon.ma-auto(size="24" :style="{ 'color': $vuetify.theme.themes[$theme].basic700 }")
                  v-col.pa-0.my-auto
                    v-layout.py-4
                      div.my-auto.pr-2
                        .s1.basic800--text Online banking
                        .c1.basic600--text(v-if="form.commitment === 'monthly'") For yearly contract only
                  v-col.pa-0.shrink.mt-5
                    v-radio.my-0.py-0.mr-2(value="fpx" readonly)

            v-card.pa-4.mt-8(v-if="selectedPaymentMethod" flat outlined style="border:1px solid var(--v-basic300);")
              card-list.mt-4(v-if="selectedPaymentMethod === 'card'" @change="form.card = $event.id")
              .online-payment.mt-4(v-else-if="selectedPaymentMethod === 'fpx'" )
                div.subtitle.mb-3 Choose bank for payment
                v-card.mb-12
                  FPXPicker(v-model="fpxBankCode")

          v-window-item(v-if="quotation" :value="2")
            // =========================================================================================================
            //  3. Confirmation
            // =========================================================================================================
            .p1.primary400--text.text-center.mt-8 Amount to be paid today
            .h5.textColor--text.text-center.mt-2 {{ quotation.total_topup_price | displayPrice }}
            .p1.primary400--text.text-center.mt-1 ({{ todayDate | displayDate }} - {{ yBooksSubscription.data.contract_end_date | displayDate }})
            v-container.text-center.mt-8
              v-row.mt-0.mb-3.ml-2.mr-2
                v-col.text-left.pa-0
                  p.mb-1.s1.primary400--text Description
                v-col.text-right.pa-0
                  p.mb-1.s1.primary400--text Amount
              v-row.mt-0.mb-0.ml-2.mr-2.pa-0(v-for="item in quotation.items" :key="item.name")
                v-col.text-left.pa-0.ma-0
                  p.p2.primary500--text.pa-0.mb-2 {{ item.add_on.feature.name }}
                v-col.text-right.pa-0.ma-0
                  p.p2.primary500--text.pa-0.mb-2 {{ item.topup_unit_price | displayPrice }}

          v-window-item(:value="3")
            // =========================================================================================================
            //  4. Thank you
            // =========================================================================================================
            .h5.textColor--text.my-8.text-center Add-on subscription successful!
            v-container.text-center
              .p1.primary400--text You can now schedule reminders for your customers’ and even your own invoices.
              .p1.primary400--text.mt-4 Happy scheduling!
              v-btn.mt-4(color="info500" dark @click="dialog=false" depressed height=32 )
                .button-AA-medium.basic100--text FINISH

      v-card-actions.pr-4
        v-spacer
        v-btn(color='white' text @click="previousStep")
          .button-Aa-medium.primary400--text {{ steps[step].secondaryButton }}
        v-btn(v-if="steps[step].primaryButton" color="info500" @click="nextStep" depressed height=40 :loading="isLoading" :disabled="steps[step].disabled")
          .button-AA-medium.basic100--text {{ steps[step].primaryButton }}

</template>

<script>
import { DateTime } from 'luxon'
import { mapState, mapActions } from 'vuex'
import { setOptions, bootstrap } from 'vue-gtag'
import CardList from '@/components/billing/CardList.vue'
import FPXPicker from '@/components/FPXPicker.vue'

export default {
  name: "SubscribeAddOnReminderModal",
  components: { CardList, FPXPicker },
  props: ['open', 'company'],
  data: (v) => ({
    isFetching: true,
    step: 0,
    contracts: [],
    selectedContract: null,
    form: {
      company: v.company.id,
      contract: null,
      card: null
    },
    quotation: null,
    isLoading: false,
    selectedPaymentMethod: null,
    fpxBankCode: null
  }),
  computed: {
    ...mapState('subscriptions', ['yBooksSubscription']),
    authMember () {
      return this.$store.state.user.member
    },
    dialog: {
      get () {
        return this.open
      },
      set (val) {
        this.$emit('update:open', val)
      }
    },
    steps () {
      return [
        { secondaryButton: 'Cancel', primaryButton: 'Next' },
        { secondaryButton: 'Back', primaryButton: 'Next', disabled: !this.selectedPaymentMethod ? true : (this.selectedPaymentMethod === 'card' ? !this.form.card : !this.fpxBankCode) },
        { title: 'Confirmation', secondaryButton: 'Back', primaryButton: 'Confirm and pay' },
        { title: 'Subscription Successful!', hidden: true, primaryButton: null }
      ]
    },
    totalPriceAmount () {
      if (!this.quotation) return 0
      return this.quotation.total_topup_price
    },
    todayDate () {
      return DateTime.local()
    }
  },
  mounted () {
    this.fetchContract()
  },
  methods: {
    ...mapActions([
      'showMessage',
      'updateCompany'
    ]),
    previousStep () {
      if (this.step === 0) {
        this.dialog = false
      } else {
        this.step--
      }
    },
    nextStep () {
      if (this.step === this.steps.length - 1) return

      if (this.step === 1) {
        if (!this.selectedPaymentMethod) {
          this.showMessage(['error', this.$t('error_message.please_select_payment_method')])
          return
        }
        this.subscription = this.yBooksSubscription.data
        const feature = 'YBOOKS_REMINDER'
        const addOn = this.selectedContract.add_ons.find( a => a.feature.code === feature)
        this.subscription.add_ons = [
          { count: 1, add_on: addOn }
        ]
        this.fetchQuotation()
        return
      } else if (this.step === 2) {
        this.clickSubscribe()
        return
      }

      this.step++
    },
    fetchQuotation () {
      this.isLoading = true
      this.$axios.post(`/subscription/subscriptions/${this.yBooksSubscription.data.id}/addon_change_quotation`, this.subscription)
        .then(resp => {
          this.quotation = resp.data
          this.step++
          if (this.quotation.waived) {
            this.clickSubscribe()
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request_contact')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    clickSubscribe () {
      this.isLoading = true
      this.$axios.patch(`/subscription/subscriptions/${this.yBooksSubscription.data.id}/`, this.subscription)
        .then(resp => {
          if (this.selectedPaymentMethod === 'card') {
            this.subscribeByCard(resp.data.bill)
          } else if (this.selectedPaymentMethod === 'fpx') {
            this.subscribeByFpx(resp.data.bill)
          }
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request_contact')])
          this.isLoading = false
        })
    },
    subscribeByCard (bill) {
      this.$axios.post(`/subscription/bills/${bill}/charge_card/`, this.form)
        .then(() => {
          this.$emit('subscribed')
          this.step++
          this.trackGtag()
          this.trackPixel()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_subscribe_card')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    subscribeByFpx (bill) {
      if (this.company.currency.currency_code === 'IDR') {
        this.form.method = 'xendit'
      } else {
        this.form.method = 'laravel'
      }
      this.form.bank_code = this.fpxBankCode
      this.$axios.post(`/subscription/bills/${bill}/request_manual_payment/`, this.form)
        .then(resp => {
          const data = resp.data
          console.log(data)
          setTimeout(() => {
            location.href = data.bill_url
          }, 1000)
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_subscribe_method')])
          this.isLoading = false
        })
    },
    fetchContract () {
      this.$axios.get(`/subscription/plans?group=YBOOKS`)
        .then(resp => {
          const bookPlans = resp.data.results
          if (bookPlans.length > 0) {
            const plan = bookPlans[0]
            this.selectedContract = plan.contracts.find( c => c.code === this.yBooksSubscription.data.contract.code)
          }
          this.isFetching = false
        })
        .catch(() => {})
    },
    trackGtag () {
      setOptions({
        config: { id: process.env.VUE_APP_YEZZA_GTAG_ID }
      })
      bootstrap().then(() => {
        this.$gtag.linker({
          'domains': ['yezza.com', 'yezza.io']
        })
        this.$gtag.purchase({
          'value': this.totalPriceAmount
        })
      })
    },
    trackPixel () {
      window.fbq('trackSingle', process.env.VUE_APP_YEZZA_FB_PIXEL_ID, 'Subscribe', {
        value: this.totalPriceAmount/this.$currency.multiplier,
        currency: this.$currency.code
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.colbox {
  border: 1px solid var(--v-primary400);
  background-color: var(--v-basic200);
  border-radius: 5px;
  text-align: center;
  padding-top: 3px;
  margin-left: 4px;
  margin-right: 4px;
  height: 32px;
  width: 60px;
}

.v-card.payment-method-selected {
  border-color: #D11184;
}

.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
</style>
